var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"close-x",attrs:{"data-testid":"closeButton"},on:{"click":_vm.closeUppy}},[_c('img',{staticClass:"close-icon",attrs:{"src":require("@/assets/images/close_icon_white.svg"),"alt":""}})]),_c('dashboard',{attrs:{"uppy":_vm.uppy,"plugins":_vm.displayPlugins,"props":{
      proudlyDisplayPoweredByUppy: false,
      locale: _vm.customDashboardHebrew,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }